import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Spin } from 'antd';
import Configure from './components/LeadomaticConfigure';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';

const mapStateToProps = state => ({
    views_permissions: state.App.Permissions.views_permissions,
    loading: state.PlatformManagement.Lead_o_matic_update.loading,
});

export default connect(mapStateToProps, null)(checkPermissionsHOC(class Index extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const view_parent_access = views_permissions['view://PlatformManagement/Lead-o-matic_update'];
        const leadomatic_create_access = views_permissions['view://PlatformManagement/Lead-o-matic_location_create'];
        const leadomatic_update_access = views_permissions['view://PlatformManagement/Lead-o-matic_location_update'];

        return (
            <Spin spinning={this.props.loading} tip="Loading ...">
                {!view_parent_access
                    ? <NotFound />
                    : (
                        <Layout className="leadomatic-update-container">
                            <h3 className="page-title">Configure Lead-o-Matic</h3>
                            <h3 className="page-subhead subhead">
                                Configure the lead rules that come into the buying division of SuperBike Factory.
                            </h3>
                            <Configure leadomatic_create_access={leadomatic_create_access} leadomatic_update_access={leadomatic_update_access} />
                        </Layout>
                    )}
            </Spin>
        );
    }
}, ['view://PlatformManagement/Lead-o-matic_update',
    'view://PlatformManagement/Lead-o-matic_location_create',
    'view://PlatformManagement/Lead-o-matic_location_update']));



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/index.js